exports.cs = {
  CSPS_DPS_CHILDREN: {
    DATE_OF_BIRTH: 'Datum narození:',
    GENDER: 'Pohlaví:',
    GENDER_MALE: 'Muž',
    GENDER_FEMALE: 'Žena',
    MONTHLY_CLIENT_CONTRIBUTION: 'Měsíční příspěvěk účastníka:',
    MONTHLY_EMPLOYER_CONTRIBUTION: 'Měsíční příspěvěk zaměstnavatele:',
    INITIAL_DEPOSIT: 'Jednorázový vklad:',
    SAVINGS: 'Naspořeno:',
    SAVINGS_CLIENT_CONTRIBUTION: 'z toho příspěvky účastníka:',
    SAVINGS_EMPLOYER_CONTRIBUTION: 'z toho příspěvky zaměstnavatele:',
    SAVINGS_STATE_CONTRIBUTION: 'z toho státní příspěvky:',
    SAVINGS_YIELD: 'z toho zhodnocení:',
    INVESTMENT_STRATEGY: 'Strategie spoření',
    FOND_KU: 'Konzervativní fond:',
    FOND_EU: 'Etický fond:',
    FOND_VU: 'Vyvážený fond:',
    FOND_DU: 'Dynamický fond:',
    SAVINGS_IN: 'Naspořeno v',
    SAVINGS_IN_60: '60 letech',
    SAVINGS_IN_PENSION: 'důchodovém věku',
    SAVINGS_STRATEGY_ERROR: 'Součet musí být roven 100 %. Aktuálně je součet %{percent} %.',
    ACTUAL_AGE: 'Aktuální věk:',
    PENSION_AMOUNT: 'Výše penze',
    CPS_EXPORT: 'Exportovat do CPS',
    CPS_EXPORT_SUCCESS: 'Úspešně odesláno',
    CPS_EXPORT_ERROR: 'Nastala chyba',
    CPS_EXPORT_SENDING: 'Odesílám...',
    RESULT: {
      RETIREMENT_AGE_YEARS: 'Věk odchodu do důchodu:',
      RETIREMENT_60_AGE_YEARS: 'Věk vzniku nároku na dávku:',
      DATE_OF_CLAIM: 'Datum nároku na částečné odbytné:',
      NOT_CHILD: 'Není nezletilec',
      NOT_PARTIAL_PENSION: 'Nemá nárok',
      EXPECTED_AVARAGE_ANNUAL_YIELD: 'Předpokládané zhodnocení strategie spoření:',
      RETIREMENT_DATE: 'Datum odchodu do důchodu:',
      RETIREMENT_60_DATE: 'Datum vzniku nároku na dávku:',
      INVESTMENT_HORIZONT: 'Doba spoření:',
      TOTAL_SAVED_AMOUNT: 'Naspořená částka:',
      SHOW_DETAIL: 'Zobrazit detail',
      HIDE_DETAIL: 'Skrýt detail',
      TOTAL_PARTY_CONTRIBUTION: 'z toho příspěvky účastníka:',
      TOTAL_EMPLOYER_CONTRIBUTION: 'z toho příspěvky zaměstnavatele:',
      TOTAL_STATE_CONTRIBUTION: 'z toho státní příspěvky:',
      TOTAL_EXPECTED_YIELD: 'z toho zhodnocení:',
      GRAPH_PARTY_CONTRIBUTION: 'Příspěvky účastníka:',
      GRAPH_EMPLOYER_CONTRIBUTION: 'Příspěvky zaměstnavatele:',
      GRAPH_STATE_CONTRIBUTION: 'Státní příspěvky:',
      GRAPH_EXPECTED_YIELD: 'Zhodnocení:',
      RETIREMENT_SAVED_AMOUNT: 'Naspořené prostředky v důchodovém věku',
      AGE60_SAVED_AMOUNT: 'Naspořené prostředky v 60 letech',
      RETIREMENT_AGE: 'Věk odchodu do důchodu:',
      SAVED_AMOUNT_IN_AGE: 'Naspořené prostředky a částečné odbytné v %{age} letech',
      PARTIAL_DISBURSEMENT_AMOUNT: 'Výše částečného odbytného:'
    }
  },
  CZK: 'Kč',
  MONTHS: '<strong>%{smart_count}</strong> měsíc |||| <strong>%{smart_count}</strong> měsíce |||| <strong>%{smart_count}</strong> měsíců',
  YEARS: '<strong>%{smart_count}</strong> rok |||| <strong>%{smart_count}</strong> roky |||| <strong>%{smart_count}</strong> let',
  MONTH_NUMBER: {
    1: 'Leden',
    2: 'Únor',
    3: 'Březen',
    4: 'Duben',
    5: 'Květen',
    6: 'Červen',
    7: 'Červenec',
    8: 'Srpen',
    9: 'Září',
    10: 'Říjen',
    11: 'Listopad',
    12: 'Prosinec'
  }
}
